type KeyType = 'type' | 'classifierId';

type GenericControlEntity<ActionType, K extends KeyType = 'type'> = Record<K, string> & {
  action: ActionType;
};

type GenericControls<ActionType, K extends KeyType = 'type'> = {
  entities: GenericControlEntity<ActionType, K>[];
};

export const syncInheritedControls = <ActionType, K extends KeyType = 'type'>(
  groupControls: GenericControls<ActionType, K>,
  orgControls: GenericControls<ActionType, K>,
  getActionLevel: (action: ActionType) => number,
  identifierKey: K
): void => {
  orgControls.entities.forEach((orgEntity) => {
    const orgIdentifier = orgEntity[identifierKey];
    const entityIndex = groupControls.entities.findIndex(
      (entity) => entity[identifierKey] === orgIdentifier
    );

    if (entityIndex > -1) {
      const { action: groupAction } = groupControls.entities[entityIndex];
      const { action: orgAction } = orgEntity;
      const orgActionLevel = getActionLevel(orgAction);
      const groupActionLevel = getActionLevel(groupAction);

      if (groupActionLevel > orgActionLevel) {
        groupControls.entities[entityIndex].action = orgAction;
      }
    } else {
      // entity not defined at group level, mirror the org definition
      groupControls.entities.push({ ...orgEntity });
    }
  });
};
